import type { IconSvgProps } from '../Icon.types';

export const CommentBoxSimple = ({ width, height }: IconSvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 12">
      <path d="M12.5 0H1.50002C1.2348 0 0.980448 0.105357 0.792911 0.292893C0.605375 0.48043 0.500018 0.734784 0.500018 1V11C0.498865 11.1907 0.55281 11.3777 0.655368 11.5384C0.757927 11.6992 0.904734 11.8269 1.07814 11.9062C1.21029 11.9678 1.35425 11.9998 1.50002 12C1.73477 11.9994 1.96174 11.9157 2.14064 11.7638L2.14627 11.7594L4.18752 10H12.5C12.7652 10 13.0196 9.89464 13.2071 9.70711C13.3947 9.51957 13.5 9.26522 13.5 9V1C13.5 0.734784 13.3947 0.48043 13.2071 0.292893C13.0196 0.105357 12.7652 0 12.5 0ZM12.5 9H4.00002C3.87996 9.00006 3.76394 9.04332 3.67314 9.12187L1.50002 11V1H12.5V9Z" />
    </svg>
  );
};
